import React, { createContext, useContext, useMemo } from 'react';
import usePollContextData from '../hooks/usePollContextData';

export type VariableContextValue = {
  variables: Store | null;
  isLoading: boolean;
};

export const VariableContext = createContext<VariableContextValue>({
  variables: null,
  isLoading: false,
});

export const useVariableContext = () => useContext(VariableContext);

type VariableContextProviderProps = {
  children: React.ReactNode | React.ReactNode[];
};

export const VariableContextProvider: React.FC<VariableContextProviderProps> = ({ children }) => {
  const { variables, isLoading } = usePollContextData();
  const value = useMemo(() => ({ variables, isLoading }), [variables, isLoading]);

  return <VariableContext.Provider value={value}>{children}</VariableContext.Provider>;
};
